export const HERE_API_KEY = 'wYZaauBZeYtKjuNeUdX558EELoYeJZ0nQFJQzI73-rw';
export const TRANSPORT_MODE = 'car';
export const ROUTING_MODE = 'fast';
